/** Placeholder exibido quando um valor monetário não veio do backend. */
export const EMPTY_VALUE = '—';

/**
 * Formata um valor monetário em BRL.
 *
 * @param value - Valor numérico; `null`/`undefined` retorna {@link EMPTY_VALUE}.
 * @returns Valor formatado (ex.: `R$ 18.400,00`) ou o placeholder.
 *
 * @example
 * ```ts
 * formatCurrency(18400);   // 'R$ 18.400,00'
 * formatCurrency(null);    // '—'
 * ```
 */
export function formatCurrency(value: number | null | undefined): string {
  if (value === null || value === undefined) return EMPTY_VALUE;
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
}
